import { useSyncExternalStore } from "react";

import { getOutcomeEntry, subscribeOutcome, type OutcomeEntry } from "../store/outcomeStore";

/**
 * 結果情報と確認済みを購読する。
 *
 * 引数が揃うまでは `null`。**取得は購読の副産物**で、`getOutcomeEntry` が最初の照会で走らせる
 * （既存の結果の器と同じ作り）。
 */
export function useOutcome(taskId: string | null, projectId: string | null): OutcomeEntry | null {
    return useSyncExternalStore(
        subscribeOutcome,
        () => getOutcomeEntry(taskId, projectId),
        () => null
    );
}
